




























import VueOptions from '@utils/VueOptions'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'AudienceCreativeFilter'

  vue:
    props: ['target', 'actions', 'options']

    components: {
      DropdownFilter,
    }

    data: ->
      selectedScope: null

    mounted: ->
      @initializeSelectedFilters()

    computed:
      defaultScope: -> 'active'

      targetScope: -> @target.scopes?[0]

      labelForScopeFilter: ->
        @optionsForScopeFilter[@targetScope || '']

      optionsForScopeFilter: ->
        '': 'All'
        'active': 'Only active'
        'inactive': 'Only deactivated'

    methods:
      initializeSelectedFilters: ->
        @selectedScope = @targetScope

      hiApplyFilters: ->
        @target.scopes = [@selectedScope]
        @actions.hiApplyFilters()

      hiClearScopeFilter: ->
        @target.scopes = [@defaultScope]
        @initializeSelectedFilters()
        @actions.hiApplyFilters()

export default VueOptions.vue settings
